<template>
    <div>
        <el-row>
          <el-col :lg="6" :offset="2">
            店櫃: <el-tag type="info" effect="dark">{{this.orderDetail.shop_name}}</el-tag>
              
          </el-col>
          <el-col :lg="6" :offset="2">
              品牌: <el-tag type="info" effect="dark">{{this.orderDetail.brand_id == 1 ? 'N牌': 'S牌'}}</el-tag>
              
          </el-col>
          <el-col :lg="6">
              建單: <el-tag type="info" effect="dark">{{this.orderDetail.user_name}}</el-tag>
          </el-col>
          
      </el-row>
      <el-row>
          <el-col :lg="6" :offset="2">
              單號: <el-tag type="info" effect="dark">{{this.orderDetail.id}}</el-tag>
              
          </el-col>
          <el-col :lg="6" :offset="2">
               日期:    <el-tag type="info" effect="dark">{{this.orderDetail.create_datetime}}</el-tag>
               
              
          </el-col>
          <el-col :lg="6">
              補單: <el-tag type="info" effect="dark">{{this.orderDetail.makeup_doc == false ? '否':'是'}}</el-tag>
              
          </el-col>
          
      </el-row>
      <el-row>
            <el-col :lg="6" :offset="2">
                姓名: <el-tag type="info" effect="dark">{{this.orderDetail.member_name}}</el-tag>
                 
          </el-col>
          <el-col :lg="6" :offset="2">
            電話: <el-tag type="info" effect="dark">{{this.orderDetail.phone}}</el-tag>
              
          </el-col>
        <el-col :lg="6">
             卡號: <el-tag type="info" effect="dark">{{this.orderDetail.card_number}}</el-tag>
             
          </el-col>
      </el-row>
      <hr />
      <el-row>
      </el-row>
      <el-row>
          <el-col :lg="6" :offset="2">
             禮卷: 
          <ul v-for="coupon in couponName" :key="coupon">
          <li>
          {{coupon.name}} x {{coupon.qty}}
          </li>
          </ul>
              
          </el-col>
          <el-col :lg="6" :offset="2" >
              折扣: <el-tag type="info" effect="dark">{{this.orderDetail.discount_name}}</el-tag>
          </el-col>
          <el-col :lg="6">點數:<el-tag type="info" effect="dark"> {{this.orderDetail.get_point}}</el-tag>
          </el-col>
      </el-row>
       <el-row>
          <el-col :lg="6" :offset="2">
              電子錢包: <el-tag type="info" effect="dark">{{this.orderDetail.use_e_pay}}</el-tag>
              
          </el-col>
          <el-col :lg="6" :offset="2">
                現金: <el-tag type="info" effect="dark">{{this.orderDetail.paid}}</el-tag>
          </el-col>
             <el-col :lg="6">
                總計: <el-tag type="info" effect="dark">{{this.orderDetail.total}}</el-tag>
                 
          
          </el-col>
      </el-row>
      <el-row>
          <el-col :lg="6" :offset="2">
               備註: <el-tag type="info" effect="dark">{{this.orderDetail.note}}</el-tag>
          </el-col>
          <el-col :lg="18" :offset="0"></el-col>
      </el-row>
      
   
      
      <el-row >
          <el-col :lg="4" :offset="20">
              <el-button type="primary" size="default" @click="chreTab()" >退換貨記錄</el-button>
              
          </el-col>
      </el-row>
      
      
      <el-row v-if="isProduct">
          <el-col :lg="22" :offset="2">
             
              <el-table
                  :data="productDetail"
                  style="width: 100%"
                  
                  >
                  <el-table-column label="產品編號" prop="id">
                     
                  </el-table-column>
                  <el-table-column label="系列別" prop="className"></el-table-column>
                  <el-table-column
                      prop="name"
                      label="名稱"
                      >
                  </el-table-column>
                  <el-table-column label="數量" prop="qty"  >
                     
                  </el-table-column>
                  <el-table-column label="單價" prop="price" ></el-table-column>
                  <el-table-column label="實付價格" prop="paid" ></el-table-column>
              </el-table>
          </el-col>
      </el-row>
      <el-row v-if="isPay">
          <el-col :lg="22" :offset="2">
             
              <el-table
                  :data="pay"
                  style="width: 100%"
                  
                  >
                  <el-table-column label="儲值" prop="pay">
                     
                  </el-table-column>
                 
              </el-table>
          </el-col>
      </el-row>
         <el-row style="margin-top: 20px;">
        <el-col :lg="11">
          
              <el-table
                  :data="shopPerformance"
                  style="width: 100%"
                  
                  >
                  <el-table-column label="店櫃" prop="name">
                    
                  </el-table-column>
                  <el-table-column label="業績" prop="count"></el-table-column>
                
              </el-table>
        </el-col>
        <el-col :lg="1">
        </el-col>
        <el-col :lg="11" :offset="1">
            
              <el-table
                  :data="userPerformance"
                  style="width: 100%"
                 
                  
                  >
                  <el-table-column label="美容師" prop="name">
                  
                  </el-table-column>
                  <el-table-column label="業績" prop="count"></el-table-column>
                 
              </el-table>
        </el-col>
    </el-row>
      
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'detail',
        props: {
            orderKey: String
        },
        data() {
            return {
                orderDetail: [],
                productDetail: [],
                qtys: [],
                couponName: [],
                userPerformance: [],
                shopPerformance: [],
                pay: [],
                isPay: false,
                isProduct: true
            }
        },
        computed: mapGetters(["getOrderDetail", "getProductDetail", "getCouponDetail", "getUserPerformance", "getShopPerformance"]),
        methods: {
            ...mapActions(["fetchOrderDetail", "fetchProductDetail", "fetchCouponDetail"]),
            async fetchOrderDetail(){
                const data = {_key: this.orderKey}
                await this.$store.dispatch('fetchOrderDetail', data)
                this.orderDetail = this.getOrderDetail
                console.log(this.orderDetail)
                this.userPerformance = this.getUserPerformance
                this.shopPerformance = this.getShopPerformance
                if (this.orderDetail.type == 1) {
                    this.isPay = false
                    this.isProduct = true
                }else {
                    this.isPay = true
                    this.isProduct = false
                    this.pay.push({
                        pay: this.orderDetail.get_e_pay
                    })
                }
                 if (this.orderDetail.items.length != 0) {
                      this.fetchProduct(this.orderDetail.items)
                 }
                if (this.orderDetail.use_coupon.length != 0) {
                    for(let i = 0; i < this.orderDetail.use_coupon.length; i ++) {
                        this.couponName.push({
                            name:this.orderDetail.use_coupon[i].name,
                            qty: this.orderDetail.use_coupon[i].qty
                        })
                    }
                }
            },
            async fetchProduct(items){
                for (let i = 0; i < items.length; i++) {
                   const data = {_key: items[i]._key, type: items[i].type}
                    await this.$store.dispatch('fetchProductDetail', data)
                          await   this.productDetail.push({
                                name: this.getProductDetail.name,
                                className: this.getProductDetail.class.name,
                                id: this.getProductDetail.id,
                                price: this.getProductDetail.price,
                                paid: items[i].paid,
                                qty: items[i].qty
                          })
                     
                    
                }
            },
            chreTab(){
                this.$emit('chreListTabs', this.orderKey)
            }
           
            
     
        },
        created() {
            this.fetchOrderDetail()
        },
    }
</script>

<style lang="scss" scoped>
    .el-row {
        margin-bottom: 20px;

        .el-tag {
            font-size: 14px;
        }
    }
    
</style>